import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useAppDispatch,useAppSelector } from '../../../app/hooks';
import { deleteTaxZoneAsync, getAccountTaxZoneByIdAsync, checkedState, unCheckedState, checkedAllState, unCheckedAllState, updateTaxZoneAsync, updateSorting } from './taxZoneSlice';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import clsx from 'clsx';
import { ShowToast } from '../../../common/Toastr';
import { setItemStatus, getValueFromResource } from '../../../common/timeLiveFunction';

const itemClass = 'ms-1 ms-lg-0';
const TaxZoneItem = (props: any) => {
    const { taxZoneList, t, onopenModal, IsEdit, IsDelete } = props;
    const { sortOrder, sortColumn, pageSize } = useAppSelector((state) => state.taxZone);


    const dispatch = useAppDispatch();
    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    const onEditClick = (AccountTaxZoneId: number) => {
        dispatch(getAccountTaxZoneByIdAsync(AccountTaxZoneId))
            .unwrap()
            .then((originalPromiseResult) => {
                onopenModal();
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const onDeleteClick = (AccountTaxZoneId: number) => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteTaxZoneAsync(AccountTaxZoneId))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Tax Zone Deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                        })
                }
            })
            .catch((error) => {
            });

    }

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };

    const handleIsDisabledChange = (e: any, taxZone: any) => {
        const { checked } = e.target;
        const foundIndex = taxZoneList.findIndex((item: any) => item.AccountTaxZoneId === taxZone.AccountTaxZoneId);
        if (foundIndex !== -1) {
            const foundItem = taxZoneList[foundIndex];
            const { isSelected, ...updatedItem } = foundItem;
            updatedItem.IsDisabled = checked;
            const modifiedList = [...taxZoneList.slice(0, foundIndex), updatedItem, ...taxZoneList.slice(foundIndex + 1)];
            dispatch(updateTaxZoneAsync(updatedItem))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast("Tax Zone Update Successfully", 'Success', "success", "toast-top-right");

                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");

                })
        }
    }
    const onHandleClientSideSorting = (sortOrder: string, sortColumn: string) => {
        dispatch(updateSorting({
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "pageSize": pageSize,
            "pageNo": 1
        }));
    }
    return (
        <>
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle "  >
                    <th style={{ width: '15%' }}>
                        {/* {t('Active / Inactive')} */}
                        {getValueFromResource('Active / Inactive',dispatch, t)}
                            {sortColumn === 'IsDisabled' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "IsDisabled") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "IsDisabled") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        <th style={{ width: '70%' }}>
                            {/* {t('Tax Zone')} */}
                            {getValueFromResource('Tax Zone',dispatch, t)}
                        {sortColumn === 'AccountTaxZone' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountTaxZone") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountTaxZone") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 0 &&
                                <><span className="cursor" onClick={() => { onHandleClientSideSorting("asc", "AccountTaxZone") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleClientSideSorting("desc", "AccountTaxZone") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}
                        </th>
                        {/* {IsEdit &&
                            <th className='w-15'>{t('Active / Inactive')}</th>
                        } */}
                        <th className='w-10 text-center'></th>
                    </tr>
                </thead>
                <tbody>
                    {taxZoneList.length === 0 && <tr><td colSpan={3}><p className='noDataFound mt-2'>
                        {/* {t('No Record Found')} */}
                        {getValueFromResource('No Record Found',dispatch, t)}
                        </p></td></tr>}
                    {taxZoneList.length > 0 && taxZoneList.map((taxZoneDetail: any, i: any) => (
                        <tr key={i}>
                            <td>
                                <span className={clsx('timeOffStatus-td app-navbar-item badge ', setItemStatus(taxZoneDetail.IsDisabled === 'No' ? "Active" : "InActive"))}>
                                    {taxZoneDetail.IsDisabled === 'No' ? "Active" : "InActive"}
                                </span>
                            </td>
                            <td className='text-gray-800  text-hover-primary custom-pointer-cursor '
                                onClick={IsEdit ? () => onEditClick(taxZoneDetail.AccountTaxZoneId) : undefined}
                            >
                                <span className="   d-block "
                                >{taxZoneDetail.AccountTaxZone}</span>
                            </td>
                            {/* {IsEdit &&
                                <td className='text-center'>
                                    <div className="form-check form-switch form-check-custom">
                                        <input
                                            type="checkbox"
                                            className="form-check-input custom-padding-right h-15px w-30px"
                                            id="IsDisabled"
                                            checked={taxZoneDetail.IsDisabled === 'Yes' ? true : false}
                                            onChange={(e) => { handleIsDisabledChange(e, taxZoneDetail) }}
                                        />
                                       
                                    </div>
                                </td>
                            } */}
                            <td className='text-center' >
                                <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}
                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>
                                            {IsEdit &&
                                                <>
                                                    <div className='menu-hover-bg-sec'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onEditClick(taxZoneDetail.AccountTaxZoneId) }}
                                                        >
                                                            <span className="menu-icon custom-menu">
                                                                <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title custom-menu-fontsize">
                                                                {/* {`${t('Edit')}`} */}
                                                                {getValueFromResource('Edit',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                            {IsDelete && IsEdit && (taxZoneDetail.MasterTaxZoneId === null || taxZoneDetail.MasterTaxZoneId === 0) &&
                                                <div className='separator mb-1 mt-1 opacity-75 '></div>
                                            }
                                            {IsDelete && (taxZoneDetail.MasterTaxZoneId === null || taxZoneDetail.MasterTaxZoneId === 0) &&
                                                <>
                                                    <div className='menu-hover-bg-danger'>
                                                        <Dropdown.Item
                                                            className="menu-item me-lg-0 "
                                                            onClick={() => { onDeleteClick(taxZoneDetail.AccountTaxZoneId) }}>
                                                            <span className="menu-icon  custom-menu">
                                                                <i className="bi bi-trash fs-6 delete-menu-icon-color allign" >
                                                                    <span className="path1"></span>
                                                                    <span className="path2"></span>
                                                                </i>
                                                            </span>
                                                            <span className="menu-title   delete-menu custom-menu-fontsize"  >
                                                                {/* {`${t('Delete')}`} */}
                                                                {getValueFromResource('Delete',dispatch, t)}
                                                                </span>
                                                        </Dropdown.Item>
                                                    </div>
                                                </>
                                            }
                                        </Dropdown.Menu>
                                    </Dropdown>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default TaxZoneItem